// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7d219446","879":"bbc74ec5","977":"fa995917"}[chunkId] + ".chunk.js";
};